import {app} from '../app.imba'

css .habitat
	d: grid
	gaf: row
	grid-gap: 4px
	fl: 1 0 240px
	.title
		d: flex
		jc: space-between
		ai: center
		mb: 8px
	p
		cursor: pointer
		zi: 10
		ta: center
		p: 13px 0
	.hab-params
		pos: relative
		d: flex
		fld: column
		g: 4px
	&.disable
		.hab-params, h2
			o: 0.5
		.hab-params
			&:before
				zi: 100
				pos: absolute
				content: ''
				l:0 t:0 r:0 b:0
	.hab-type
		pos: relative
		d: grid
		gaf: column
		bd: 1px solid rgba(255, 192, 0, 0.25)
		&::before
			content: ''
			pos: absolute
			t: 0
			l: 0
			r: 0
			b: 0
			w: 1px
			bg: rgba(255, 192, 0, 0.25)
			m: auto
		&::after
			d: none
			content: ''
			pos: absolute
			t: 0 b: 0 l: 0
			w: 50%
			bg: rgba(255, 192, 0, 0.1)
			m: auto
			ml: 0
			tween: margin-left 0.2s ease
		&.genesis
			& > p
				&:first-child
					cursor: default
					c: rgba(255, 192, 0, 1)
			&::after
				d: block
				ml: 0%
		&.normal
			& > p
				&:last-child
					cursor: default
					c: rgba(255, 192, 0, 1)
			&::after
				d: block
				ml: 50%
	.hab-lvl
		pos: relative
		d: grid
		gaf: column
		bd: 1px solid rgba(255, 192, 0, 0.25)
		&::before
			content: ''
			pos: absolute
			t: 0 b: 0 l: calc(33.3333% - 1px)
			w: 33.3333%
			bd: 1px solid rgba(255, 192, 0, 0.25)
			bdt: none bdb: none
			m: auto
		&::after
			d: none
			content: ''
			pos: absolute
			t: 0 b: 0 l: 0
			w: 33.3333%
			bg: rgba(255, 192, 0, 0.1)
			m: auto
			ml: 0
			tween: margin-left 0.2s ease
		&.first
			& > p
				&:first-child
					cursor: default
					c: rgba(255, 192, 0, 1)
			&::after
				d: block
				ml: 0%
		&.second
			& > p
				&:nth-child(2)
					cursor: default
					c: rgba(255, 192, 0, 1)
			&::after
				d: block
				ml: 33.3333%
		&.third
			& > p
				&:last-child
					cursor: default
					c: rgba(255, 192, 0, 1)
			&::after
				d: block
				ml: 66.6666%

export tag Habitat
	prop id
	prop name = 'Habitat name'

	def render
		<self.habitat .disable=(app.habs[id].onoff == false)>
			<.title>
				<h2> name
				if app.habs[id].sub == true
					<.switch .active=(app.habs[id].onoff == true) @click=(app.habs[id].onoff = !app.habs[id].onoff)>		
			<.hab-params @click=(if app.habs[id].onoff == false then app.habs[id].onoff = true)>
				<.hab-type .genesis=(app.habs[id].onoff == true && app.habs[id].type == 'gen') .normal=(app.habs[id].onoff == true && app.habs[id].type == 'norm')>
					<p @click=(app.habs[id].type = 'gen')> app.trans.type-gen[app.lg]
					<p @click=(app.habs[id].type = 'norm')> app.trans.type-nor[app.lg]
				<.hab-lvl .first=(app.habs[id].onoff == true && app.habs[id].lvl == 0) .second=(app.habs[id].onoff == true && app.habs[id].lvl == 1) .third=(app.habs[id].onoff == true && app.habs[id].lvl == 2)>
					<p @click=(app.habs[id].lvl = 0)> '1 ' + app.trans.level[app.lg]
					<p @click=(app.habs[id].lvl = 1)> '2 ' + app.trans.level[app.lg]
					<p @click=(app.habs[id].lvl = 2)> '3 ' + app.trans.level[app.lg]